import { useEffect, useState } from "react";
import { CheckCircle2, HelpCircle } from "lucide-react";
import { ModalNovoChamado } from "./ModalNovoChamado";

export function FABChamados() {
  const [modalOpen, setModalOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (!showSuccess) return;
    const timeout = window.setTimeout(() => setShowSuccess(false), 3_500);
    return () => window.clearTimeout(timeout);
  }, [showSuccess]);

  return (
    <>
      {!modalOpen && (
        <button
          type="button"
          onClick={() => setModalOpen(true)}
          className="no-print fixed bottom-6 right-6 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-brand-600 text-white shadow-lg transition-all hover:scale-105 hover:bg-brand-700 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
          aria-label="Abrir chamado de TI"
          title="Precisa de ajuda? Abra um chamado"
        >
          <HelpCircle className="h-7 w-7" />
        </button>
      )}

      {showSuccess && (
        <div
          className="fixed bottom-24 right-6 z-[70] flex items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-medium text-emerald-800 shadow-lg"
          role="status"
        >
          <CheckCircle2 className="h-4 w-4" />
          Chamado enviado para a equipe de TI.
        </div>
      )}

      {modalOpen && (
        <ModalNovoChamado
          open
          onClose={() => setModalOpen(false)}
          onCreated={() => setShowSuccess(true)}
        />
      )}
    </>
  );
}
